import ManufacturerFilter from './ManufacturerFilter';

export default ManufacturerFilter;
